var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFinancial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 75,
    viewBox: "0 0 59 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 75,
    rx: 2,
    fill: "#D6E8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 46,
    width: 28,
    height: 4,
    rx: 1,
    fill: "#4B81AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 39,
    width: 28,
    height: 4,
    rx: 1,
    fill: "#4B81AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7717 48.0949C16.8301 48.0949 17.7222 47.6766 18.4479 46.84L20.0053 48.2915C19.5013 48.9064 18.8763 49.3751 18.1304 49.6977C17.3946 50.0202 16.568 50.1815 15.6507 50.1815C14.7738 50.1815 13.9573 50.0253 13.2013 49.7128C12.4554 49.4003 11.8203 48.9568 11.2962 48.3822C10.772 47.8077 10.394 47.1424 10.1622 46.3864H8.45361V45.1163H9.93537C9.92529 45.0256 9.92025 44.8895 9.92025 44.7081C9.92025 44.5266 9.92529 44.3905 9.93537 44.2998H8.45361V43.0297H10.1622C10.394 42.2737 10.772 41.6085 11.2962 41.0339C11.8203 40.4593 12.4554 40.0158 13.2013 39.7033C13.9573 39.3909 14.7738 39.2346 15.6507 39.2346C16.568 39.2346 17.3946 39.3959 18.1304 39.7185C18.8763 40.041 19.5013 40.5047 20.0053 41.1095L18.4479 42.561C17.7121 41.7345 16.82 41.3212 15.7717 41.3212C15.1064 41.3212 14.5117 41.4724 13.9875 41.7748C13.4634 42.0772 13.0602 42.4955 12.7779 43.0297H16.6033V44.2998H12.3999C12.3899 44.3905 12.3848 44.5266 12.3848 44.7081C12.3848 44.8895 12.3899 45.0256 12.3999 45.1163H16.6033V46.3864H12.7779C13.0602 46.9206 13.4634 47.3389 13.9875 47.6413C14.5117 47.9437 15.1064 48.0949 15.7717 48.0949Z",
    fill: "#093E62"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 53,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#4B81AC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 60,
    width: 28,
    height: 4,
    rx: 1,
    fill: "#4B81AC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 12,
    height: 6,
    rx: 1,
    transform: "rotate(-90 13 31)",
    fill: "#3F936A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 31,
    width: 23,
    height: 6,
    rx: 1,
    transform: "rotate(-90 22 31)",
    fill: "#3F936A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 17,
    height: 6,
    rx: 1,
    transform: "rotate(-90 31 31)",
    fill: "#3F936A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 31,
    width: 20,
    height: 6,
    rx: 1,
    transform: "rotate(-90 40 31)",
    fill: "#3F936A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20.0517L35.445 26.0585C34.5898 26.5961 33.468 26.4117 32.83 25.6286L24.5729 15.4944C23.8933 14.6603 22.6756 14.5133 21.817 15.1617L10 24.0862",
    stroke: "#2A5B43",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17.4516L45.3429 24L49 17L41 17.4516Z",
    fill: "#2A5B43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFinancial);
export default __webpack_public_path__ + "static/media/imgFinancial.4d94b3990c8df04f7ecc4548d3498e3b.svg";
export { ForwardRef as ReactComponent };